import React, { useState, useEffect, useContext, Fragment } from 'react';

import Button from 'b2b-ui-components-lib/lib/components/button';

import AddressProcess from 'home/view/manage-feasibility/components/organisms/addressProcessAOI/addressProcess';
import DrawerModalComponent from 'home/view/manage-feasibility/components/organisms/drawer_modal';

import CancelModal from 'home/view/manage-feasibility/components/molecules/CancelModal';

import { AppContext } from 'App';

import { cancelLead, fetchLocationDetails, bulkFeasibilityCheck, upgradeFetchCircuitDetails, sampleDownload } from 'home/view/manage-feasibility/services';

import {
  getProductType,
  isNLD_OR_LL,
  ROUTES,
  isBulkUpgrade,
  DEDICATED_COMMON_PARAMS,
  isVPN_OR_DI,
  VPN_SITE_TYPE,
  MAX_RETRY_COUNT,
  isAOIOrder
} from 'common/constants/app.constants';

import {
  MULTI_SITE_MODULE_ID,
  FEASIBILITY_SUCCESS,
  AUTH_TOKEN,
  RETRY_COUNT,
  LEAD_ID,
  FILTER_TYPES,
  SHORT_CB_DELAY,
  CALLBACK_DELAY,
  SUCCESS_TOAST,
  DEFAULT_TOAST_MSG,
  ERROR_TOAST,
  FILE_UPLOAD_PAGES,
  LINE_ITEM_FIELDS_PARAMS
} from 'home/view/manage-feasibility/constants';

import {
  setInSessionStorage,
  getFromSessionStorage,
  findParamFromUrl,
  isAuthForDev,
  isDevEnv,
  getOrderDetails,
  getCurrentServiceType,
  removeLastString,
  removeUnderScoreWithSpace,
  showNotification
} from 'common/utils/app.utils';

import { downloadFileURI, getFileName, useInterval } from 'home/view/manage-feasibility/utils';

import './index.scss';
import { FEASIBILITY_LOCATION_STATUS, INVALID_SITES_ADDRESS_RESOLUTION, INVALID_SITES_FEASIBILITY, TOOLTIP_MESSAGE, WARNING_TOAST } from '../../constants/multiSite-constants';
import {
  DI_ADDRESS_HEADER,
  VPN_ADDRESS_HEADER,
  NLD_LL_ADDRESS_HEADER,
  BULK_TABLE_HEADER,
  AOI_1000_SITES_CART,
  AOI_1000_SITES_ADDRESS_HEADER
} from '../../constants/table-constant';
import { getNotificationTextOnCircuitUpload, getDownloadModalText, getDownloadText, getUploadModalText } from 'home/view/check-feasibility/comp-generator/component.generator';
// import { NOTIFICATION_TYPE } from 'common/components/notification-component/notification.constant.js';
import { NOTIFICATION_TYPE } from 'featureLib/NotificationComponent';
import CircuitDetail from 'home/view/manage-feasibility/components/organisms/CircuitDetail/CircuitDetail';
import RetryComponent from './RetryComponent';
import { getCurrentLead } from 'tokenGeneration/lead.util';
import BottomSection from '../../components/molecules/BottomSection';
import { MODULE_ID } from 'dedicated/components/summary/kdmDetails/documents/constant';

const defaultDataPerPageOptions = [
  { displayName: 'Show 10 Rows', key: '10' },
  { displayName: 'Show 20 Rows', key: '20' },
  { displayName: 'Show 30 Rows', key: '30' },
  { displayName: 'Show 40 Rows', key: '40' },
  { displayName: 'Show 50 Rows', key: '50' },
  { displayName: 'Show 60 Rows', key: '60' },
  { displayName: 'Show 70 Rows', key: '70' },
  { displayName: 'Show 80 Rows', key: '80' },
  { displayName: 'Show 90 Rows', key: '90' },
  { displayName: 'Show 100 Rows', key: '100' }
];

const defaultFilterOptions = [{ key: 'bandwidth', displayName: 'All' }];

const defaultSearchTypeOptions = [
  {
    key: 'pincode',
    displayName: 'PinCode',
    type: FILTER_TYPES.INPUT,
    regex: '[0-9]\\d*$'
  },
  {
    key: 'companyName',
    displayName: 'CompanyName',
    type: FILTER_TYPES.INPUT
  }
];

const AddressResolutionComponent = ({ isAOI = false, setAccordionStateAOI = false, addressResolutionAOIComponent = false, ...props }) => {
  const partyId = findParamFromUrl('partyId', false);
  const leadIdFromParam = findParamFromUrl('leadId', false);

  const getTableHeaders = () => {
    if (isAOI) {
      return AOI_1000_SITES_ADDRESS_HEADER;
    }

    if (isNLD_OR_LL()) {
      return NLD_LL_ADDRESS_HEADER;
    }

    if (isBulkUpgrade()) {
      return BULK_TABLE_HEADER;
    }
    return VPN_ADDRESS_HEADER;
  };

  const tableHeader = getTableHeaders();

  const { isdedicatedJourney, history } = props;
  const { toast, setToast, showSteps } = useContext(AppContext);

  const [showLoader, setShowLoader] = useState(false);
  const [totalSitesProcessed, setTotalSitesProcessed] = useState(0);
  const [totalSitesProcessing, setTotalSitesProcessing] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [locationStatusMap, setLocationStatusMap] = useState(0);
  const [downloadPercentage, setDownloadPercentage] = useState(0);
  const [filterList, setFilterList] = useState([]);
  const [filterValue, setFilterValue] = useState(defaultFilterOptions[0]);
  const [searchType, setSearchType] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [tableRows, setTableRows] = useState(tableHeader);
  const [tableColumns, setTableColumns] = useState([]);
  const [dataPerPageValue, setDataPerPageValue] = useState(defaultDataPerPageOptions[0]);
  const [dataPerPageOptions, setDataPerPageOptions] = useState(defaultDataPerPageOptions);
  const [currentPage, setCurrentPage] = useState(1);
  const [showEditModal, setShowEditModal] = useState(false);

  const [filterApplied, setFiltersApplied] = useState(false);
  const [multiSortArr, setMultiSortArr] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [showCanceLeadPopup, setShowCancelLeadPopup] = useState(false);
  const [showStaticNotification, setShowStaticNotification] = useState({ show: false, type: '', props: {} });
  const [circuitModalDataSet, setCircuitModalData] = useState({});
  const [showCircuitDetailModal, setShowCircuitDetailModal] = useState(false);
  const [showRetry, setShowRetry] = useState(false);
  const [feasibilityCheckInProgress, setFeasibilityCheckInProgress] = useState(false);

  const retryCount = getFromSessionStorage(MULTI_SITE_MODULE_ID, RETRY_COUNT) ?? 0;

  useEffect(() => {
    // showSteps(true);
    // disableBackButton();
    toggelToastPopup();
    if (isBulkUpgrade()) {
      handleFetchLocations(null, null, null, false);
    }
  }, []);

  const getCbInterval = () => {
    return parseInt(downloadPercentage) === 100 ? null : showRetry ? CALLBACK_DELAY : SHORT_CB_DELAY;
  };

  const getToastMessage = (isEdit, locationStatusMap,totalActiveAddressCount) => {
    if (isNLD_OR_LL() && locationStatusMap?.[FEASIBILITY_LOCATION_STATUS.INVALID_ADDRESS] > 0) {
      return {
        toastMsg: `There are errors in ${locationStatusMap?.[FEASIBILITY_LOCATION_STATUS.INVALID_ADDRESS]} sites. Please resolve or remove site having errors to proceed `,
        type: ERROR_TOAST
      };
    }
    const toastMsg = isEdit
      ? 'Edit_Bulk_Address_DI.xlsx has been successfully overwritten and uploaded on the system. You may proceed with the feasibility results.'
      : `${locationStatusMap && locationStatusMap.INVALID_PINCODE && totalActiveAddressCount ? totalActiveAddressCount :'All'} ${isNLD_OR_LL() ? 'links' : 'sites'} are successfully processed and uploaded on the system. You may proceed with the feasibility result.`;

    return { toastMsg, type: SUCCESS_TOAST };
  };

  const addSiteTypeColumnForVPN = (item) => {
    let bandwidth = item && item.feasibilityResponseBulk && item.feasibilityResponseBulk.requestedBandwidth && item.feasibilityResponseBulk.requestedBandwidth.toString();
    if (item?.lineItemId) {
      return {
        col5: {
          data: item?.siteType || '-'
        },
        col6: {
          data: bandwidth ? `${bandwidth} Mbps` : '-'
        }
      };
    }
    return {
      col5: {
        data: bandwidth ? `${bandwidth} Mbps` : '-'
      }
    };
  };

  const getColumnsForNLDorLL = (item, hasAddressError, hasPincodeError) => {
    let bandwidth = item.feasibilityResponseBulk.requestedBandwidth && item.feasibilityResponseBulk.requestedBandwidth.toString();

    let installationAddress = `${item.address.addressLine1}, ${item.address.state ? `${item.address.state},` : ''} ${item.address.country}`;
    return {
      col1: {
        data: item.linkId || '-',
        expandRow: true,
        rowSpan: 2
      },
      col2: {
        data: bandwidth ? `${bandwidth} Mbps` : '-',
        expandRow: true,
        rowSpan: 2
      },
      col3: {
        data: removeUnderScoreWithSpace(item?.siteType) || '-'
      },
      col4: {
        data: installationAddress || '-',
        subData: `Branch Code: ${item.branchCode || '-'}`,
        hasError: hasAddressError,
        locationStatus: item?.locationStatus,
        locationStatusMap
      },
      col5: {
        data: item.address.companyName || '-'
      },
      col6: {
        data: item.address.pincode || '-',
        hasError: hasPincodeError
      }
    };
  };

  const getColumnsForAOI = (item, hasAddressError, hasPincodeError) => {
    let installationAddress = `${item.address.addressLine1}, ${item.address.state ? `${item.address.state},` : ''} ${item.address.country}`;
    return {
      col1: {
        data: item.feasibilityId || '-', // use feasibility ID here
        expandRow: true,
        rowSpan: 2
      },

      // col2: {
      //   data: item.address.companyName || '-'
      // },

      col2: {
        data: installationAddress || '-',
        // subData: `Branch Code: ${item.branchCode || '-'}`,
        hasError: hasAddressError,
        locationStatus: item?.locationStatus,
        locationStatusMap
      },

      col3: {
        data: item.address.pincode || '-',
        hasError: hasPincodeError
      },

      col4: {
        data: '-'
      }
    };
  };

  const getColumnsForDI_VPN = (item, hasAddressError, hasPincodeError) => {
    let installationAddress = `${item.address.addressLine1}, ${item.address.state ? `${item.address.state},` : ''} ${item.address.country}`;
    return {
      col1: {
        data: isAOIOrder() ? item.lineItemId : removeLastString(item.lineItemId) || '-',
        expandRow: item?.dualLastMile,
        rowSpan: 2
      },
      col2: {
        data: item.address.companyName || '-',
        expandRow: item?.dualLastMile,
        rowSpan: 2
      },
      col3: {
        data: installationAddress || '-',
        subData: isAOIOrder() ? null : `Branch Code: ${item.branchCode || '-'}`,
        hasError: hasAddressError,
        locationStatus: item?.locationStatus,
        locationStatusMap,
        expandRow: item?.dualLastMile,
        rowSpan: 2
      },
      col4: {
        data: item.address.pincode || '-',
        hasError: hasPincodeError,
        expandRow: item?.dualLastMile,
        rowSpan: 2
      },
      ...addSiteTypeColumnForVPN(item)
    };
  };

  const downloadInvalidCircuits = async () => {
    try {
      const { res, err } = await sampleDownload(isdedicatedJourney, true);

      if (res) {
        const { data = {} } = res;

        const fileName = getFileName(res, 'Invalid_Circuits.xlsx');
        downloadFileURI(data, fileName);
      } else if (err) {
        const error = await (err && err.response && err.response.data && err.response.data.text());
        const parsedError = JSON.parse(error);
        const errorMsg = (parsedError && parsedError.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const downloadNewOrderInvalidCircuits = async () => {
    try {
      const { res, err } = await sampleDownload(isdedicatedJourney, false, INVALID_SITES_ADDRESS_RESOLUTION);

      if (res) {
        const { data = {} } = res;

        const fileName = getFileName(res, 'Invalid_Sites.xlsx');
        downloadFileURI(data, fileName);
      } else if (err) {
        const error = await (err && err.response && err.response.data && err.response.data.text());
        const parsedError = JSON.parse(error);
        const errorMsg = (parsedError && parsedError.errorMsg) || DEFAULT_TOAST_MSG;

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const downloadInvalidFeasibilityId = async () => {
    try {
      setShowLoader(true);
      const { res, err } = await sampleDownload(isdedicatedJourney, false, INVALID_SITES_FEASIBILITY);

      if (res) {
        setShowLoader(false);
        const { data = {} } = res;

        const fileName = getFileName(res, 'Invalid_Circuits.xlsx');
        downloadFileURI(data, fileName);
      } else if (err) {
        const error = await (err && err.response && err.response.data && err.response.data.text());
        const parsedError = JSON.parse(error);
        const errorMsg = (parsedError && parsedError.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const renderCircuitDetailModal = async (circuitId) => {
    setShowLoader(true);
    try {
      const { res, err } = await upgradeFetchCircuitDetails(circuitId);

      if (res) {
        setShowLoader(false);

        const { data: { success = false, result = {} } = {} } = res;
        if (success) {
          setCircuitModalData(result);
          setShowCircuitDetailModal(true);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getBulkUpgradeRowData = (item) => {
    const {
      circuitId,
      branchCode,
      lsiDetail: {
        currentBandwidth,
        currentMedia,
        currentServiceType,
        installationAddress: { addressLine1, state, country } = {
          addressLine1: '',
          state: '',
          country: ''
        },
        requestedBandwidth,
        requestedHardwareType,
        requestedRouterMake,
        requestedRouterModel,
        requestedServiceType
      }
    } = item;

    const circuitEle = (
      <a href="javascript:void(0);" role="button" tabIndex={0} className="anchor-style" onClick={() => renderCircuitDetailModal(circuitId)} title={circuitId}>
        {circuitId}
      </a>
    );

    const installationAddressEle = addressLine1 ? `${addressLine1}, ${state ? `${state},` : ''} ${country}` : '-';

    const getHardwareColumnData = () => {
      if (requestedServiceType === 'MANAGED') {
        return {
          data: getCurrentServiceType(requestedServiceType),
          subData: `${requestedHardwareType} Hardware`
        };
      }

      return {
        data: getCurrentServiceType(requestedServiceType),
        subData: '-'
      };
    };

    const getRouterMakeModelColumnData = () => {
      if (requestedServiceType === 'MANAGED') {
        return {
          data: requestedRouterMake && requestedRouterMake.toUpperCase(),
          subData: requestedRouterModel && requestedRouterModel.toUpperCase()
        };
      }

      return {
        data: '-'
      };
    };

    return {
      col1: {
        data: circuitEle || '-'
      },
      col2: {
        data: installationAddressEle,
        subData: `Branch Code: ${branchCode || '-'}`
      },
      col3: {
        data: currentBandwidth,
        subData: `Media Type: ${currentMedia}`
      },
      col4: {
        data: getCurrentServiceType(currentServiceType)
      },
      col5: {
        data: `${requestedBandwidth} Mbps`
      },
      col6: getHardwareColumnData(),
      col7: getRouterMakeModelColumnData()
    };
  };

  const getFieldsParam = () => {
    if (isBulkUpgrade()) {
      return LINE_ITEM_FIELDS_PARAMS.LINEITEM_STATUS_MAP;
    }

    return `${LINE_ITEM_FIELDS_PARAMS.LOCATION_STATUS_MAP},${LINE_ITEM_FIELDS_PARAMS.LINEITEM_STATUS_MAP}`;
  };

  const handleFetchLocations = async (page, size, filterParams = {}, isFilterApplied = filterApplied) => {
    try {
      setShowRetry(false);
      setShowLoader(true);

      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);
      const activePage = page || currentPage - 1;
      const activeDataPerPage = size || (dataPerPageValue && dataPerPageValue.key);

      const defaultFilterParam = {
        fields: getFieldsParam()
      };

      filterParams = { ...defaultFilterParam, ...filterParams };

      const { res, err } = await fetchLocationDetails(leadAuthToken, activePage, activeDataPerPage, filterParams ? filterParams : {});

      if (res) {
        const { data: { success = false, result = {} } = {} } = res;
        const handleBulkUpgradeResolution = () => {
          const { totalAddressesCount, totalActiveAddressCount, totalElement, totalPages, content, lineItemStatusMap } = result;

          const { ACTIVE, INVALID_SITE } = lineItemStatusMap;

          if (success) {
            const updatedRetryCount = retryCount + 1;
            setInSessionStorage(MULTI_SITE_MODULE_ID, RETRY_COUNT, updatedRetryCount);

            const tableRowList = [];
            let percentDownloaded = 0;

            const { toastMsg, type } = getToastMessage(isEdit, {});

            const totalFeasibilitySum = Object.values(lineItemStatusMap).reduce((a, b) => a + b, 0);
            percentDownloaded = ((totalFeasibilitySum / totalAddressesCount) * 100).toFixed();
            const isPercentCalculatedNaN = isNaN(parseInt(percentDownloaded));
            percentDownloaded = isPercentCalculatedNaN ? 0 : parseInt(percentDownloaded) > 100 ? 100 : percentDownloaded; // API handling for scenarios where totalElement resolved is coming greater than totalAddressCount.

            parseInt(percentDownloaded) === 100 && totalAddressesCount > 0 && getTotalIncAddCountAndBwList(totalAddressesCount);

            setDownloadPercentage(percentDownloaded);
            setTotalPages(totalPages);

            setTotalSitesProcessing(totalElement);
            setTotalSitesProcessed(totalAddressesCount);

            if (parseInt(percentDownloaded) === 100) {
              if (INVALID_SITE > 0) {
                const notificationProps = {
                  invalidElements: INVALID_SITE,
                  productType: DEDICATED_COMMON_PARAMS.serviceType,
                  download: downloadInvalidCircuits,
                  message: `* Error found in ${INVALID_SITE} ${INVALID_SITE > 1 ? 'circuits' : 'circuit'}`
                };
                setShowStaticNotification({
                  show: true,
                  type: NOTIFICATION_TYPE.WARNING,
                  props: notificationProps
                });

                if (isEdit) {
                  setToast(true, toastMsg, type);
                }
              } else if (ACTIVE === totalAddressesCount) {
                const notificationProps = {
                  resolvedCircuitElements: ACTIVE,
                  productType: DEDICATED_COMMON_PARAMS.serviceType,
                  handleGotoCheckFeasibility
                };
                setShowStaticNotification({
                  show: true,
                  type: NOTIFICATION_TYPE.SUCCESS,
                  props: notificationProps
                });

                if (isEdit) {
                  setToast(true, toastMsg, type);
                }
              } else {
                // re-upload sheet and none of the above case matches
                setShowStaticNotification({
                  show: false,
                  type: '',
                  props: {}
                });
              }
            }

            if (content && content.length > 0) {
              setShowLoader(false);

              content.forEach((item) => {
                const rows = getBulkUpgradeRowData(item);
                tableRowList.push(rows);
              });
            }

            if (content?.length === 0 && retryCount > MAX_RETRY_COUNT) {
              setShowRetry(true);
              setInSessionStorage(MULTI_SITE_MODULE_ID, RETRY_COUNT, 0);
            }

            setTableColumns(tableRowList);
          }
        };

        const handleMultiSiteNLDLLResolution = () => {
          const {
            totalAddressesCount = '',
            totalActiveAddressCount = 0,
            totalElement = '',
            totalPages,
            content = [],
            locationStatusMap = {},
            lineItemStatusMap: { ACTIVE, INVALID_SITE }
          } = result;

          if (success) {
            const updatedRetryCount = retryCount + 1;
            setInSessionStorage(MULTI_SITE_MODULE_ID, RETRY_COUNT, updatedRetryCount);

            const tableColumnsList = [];
            const inValidFeasibilityIdCount = locationStatusMap['INVALID_FEASIBILITY_ID'] ?? 0;

            let percentDownloaded = 0;

            setLocationStatusMap(locationStatusMap);

            const totalFeasibilitySum = Object.values(locationStatusMap).reduce((a, b) => a + b, 0);
            percentDownloaded = ((totalFeasibilitySum / totalAddressesCount) * 100).toFixed();
            const isPercentCalculatedNaN = isNaN(parseInt(percentDownloaded));
            percentDownloaded = isPercentCalculatedNaN ? 0 : parseInt(percentDownloaded) > 100 ? 100 : percentDownloaded; // API handling for scenarios where totalElement resolved is coming greater than totalAddressCount.

            const { toastMsg, type } = getToastMessage(isEdit, locationStatusMap,totalActiveAddressCount);

            parseInt(percentDownloaded) === 100 && !inValidFeasibilityIdCount && setToast(true, toastMsg, type);
            parseInt(percentDownloaded) === 100 && totalAddressesCount > 0 && getTotalIncAddCountAndBwList(totalAddressesCount);

            setDownloadPercentage(percentDownloaded);

            setTotalPages(totalPages);
            if (parseInt(percentDownloaded) === 100) {
              if (INVALID_SITE > 0) {
                const notificationProps = {
                  invalidElements: INVALID_SITE,
                  productType: DEDICATED_COMMON_PARAMS.serviceType,
                  download: downloadNewOrderInvalidCircuits,
                  message: `* Error found in ${INVALID_SITE} ${INVALID_SITE > 1 ? 'sites' : 'site'}`
                };
                setShowStaticNotification({
                  show: true,
                  type: NOTIFICATION_TYPE.WARNING,
                  props: notificationProps
                });
              } else if (inValidFeasibilityIdCount > 0) {
                const notificationProps = {
                  resolvedCircuitElements: 0,
                  invalidElements: inValidFeasibilityIdCount,
                  productType: DEDICATED_COMMON_PARAMS.serviceType,
                  handleGotoCheckFeasibility,
                  download: downloadInvalidFeasibilityId,
                  message: `* Error found for ${inValidFeasibilityIdCount} ${inValidFeasibilityIdCount > 1 ? 'feasibility Ids' : 'feasibility Id'}. `
                };
                setShowStaticNotification({
                  show: true,
                  type: NOTIFICATION_TYPE.WARNING,
                  props: notificationProps
                });
              } else if (ACTIVE < totalAddressesCount) {
                const notificationProps = {
                  resolvedCircuitElements: ACTIVE,
                  totalAddressesCount,
                  productType: DEDICATED_COMMON_PARAMS.serviceType,
                  handleGotoCheckFeasibility
                };
                setShowStaticNotification({
                  show: true,
                  type: NOTIFICATION_TYPE.SUCCESS,
                  props: notificationProps
                });
              } else {
                // re-upload sheet and none of the above case matches
                setShowStaticNotification({
                  show: false,
                  type: '',
                  props: {}
                });
              }
            }

            if (isNLD_OR_LL()) {
              setTotalSitesProcessing(Math.floor(totalElement / 2));
              setTotalSitesProcessed(Math.floor(totalAddressesCount / 2));
            } else {
              setTotalSitesProcessing(totalElement);
              setTotalSitesProcessed(totalAddressesCount);
            }

            if (content && content.length > 0) {
              setShowLoader(false);

              content.forEach((item) => {
                let hasPincodeError = false;
                let hasAddressError = false;

                if (item.locationStatus === FEASIBILITY_LOCATION_STATUS.ADDRESS_INCOMPLETE) {
                  hasAddressError = true;
                }

                if (item.locationStatus === 'PIN_INCOMPLETE') {
                  hasPincodeError = true;
                }

                const columns = isNLD_OR_LL() ? getColumnsForNLDorLL(item, hasAddressError, hasPincodeError) : getColumnsForDI_VPN(item, hasAddressError, hasPincodeError);
                tableColumnsList.push(columns);
              });
            }

            if (content?.length === 0 && retryCount > MAX_RETRY_COUNT) {
              setShowRetry(true);
              setInSessionStorage(MULTI_SITE_MODULE_ID, RETRY_COUNT, 0);
            }

            setTableColumns(tableColumnsList);
          }
        };

        const handleAOIResolution = () => {
          const {
            totalAddressesCount = '',
            totalActiveAddressCount = 0,
            totalElement = '',
            totalPages,
            content = [],
            locationStatusMap = {},
            lineItemStatusMap: { ACTIVE, INVALID_SITE }
          } = result;

          if (success) {
            setFiltersApplied(false);
            const updatedRetryCount = retryCount + 1;
            setInSessionStorage(MULTI_SITE_MODULE_ID, RETRY_COUNT, updatedRetryCount);

            const tableColumnsList = [];
            const inValidFeasibilityIdCount = locationStatusMap['INVALID_FEASIBILITY_ID'] ?? 0;

            let percentDownloaded = 0;

            setLocationStatusMap(locationStatusMap);

            const totalFeasibilitySum = Object.values(locationStatusMap).reduce((a, b) => a + b, 0);
            percentDownloaded = ((totalFeasibilitySum / totalAddressesCount) * 100).toFixed();
            const isPercentCalculatedNaN = isNaN(parseInt(percentDownloaded));
            percentDownloaded = isPercentCalculatedNaN ? 0 : parseInt(percentDownloaded) > 100 ? 100 : percentDownloaded; // API handling for scenarios where totalElement resolved is coming greater than totalAddressCount.

            const { toastMsg, type } = getToastMessage(isEdit, locationStatusMap,totalActiveAddressCount);

            parseInt(percentDownloaded) === 100 && !inValidFeasibilityIdCount && setToast(true, toastMsg, type);
            parseInt(percentDownloaded) === 100 && totalAddressesCount > 0 && getTotalIncAddCountAndBwList(totalAddressesCount);

            setDownloadPercentage(percentDownloaded);

            setTotalPages(totalPages);

            if (parseInt(percentDownloaded) === 100) {
              if (INVALID_SITE > 0) {
                const notificationProps = {
                  invalidElements: INVALID_SITE,
                  productType: DEDICATED_COMMON_PARAMS.serviceType,
                  download: downloadNewOrderInvalidCircuits,
                  message: `* Error found in ${INVALID_SITE} ${INVALID_SITE > 1 ? 'sites' : 'site'}`
                };
                setShowStaticNotification({
                  show: true,
                  type: NOTIFICATION_TYPE.WARNING,
                  props: notificationProps
                });
              } else if (inValidFeasibilityIdCount > 0) {
                const notificationProps = {
                  resolvedCircuitElements: 0,
                  invalidElements: inValidFeasibilityIdCount,
                  productType: DEDICATED_COMMON_PARAMS.serviceType,
                  handleGotoCheckFeasibility,
                  download: downloadInvalidFeasibilityId,
                  message: `* Error found for ${inValidFeasibilityIdCount} ${inValidFeasibilityIdCount > 1 ? 'feasibility Ids' : 'feasibility Id'}. `
                };
                setShowStaticNotification({
                  show: true,
                  type: NOTIFICATION_TYPE.WARNING,
                  props: notificationProps
                });
              } else if (ACTIVE < totalAddressesCount) {
                const notificationProps = {
                  resolvedCircuitElements: ACTIVE,
                  totalAddressesCount,
                  productType: DEDICATED_COMMON_PARAMS.serviceType,
                  handleGotoCheckFeasibility
                };
                setShowStaticNotification({
                  show: true,
                  type: NOTIFICATION_TYPE.SUCCESS,
                  props: notificationProps
                });
              } else {
                // re-upload sheet and none of the above case matches
                setShowStaticNotification({
                  show: false,
                  type: '',
                  props: {}
                });
              }
            }

            if (isNLD_OR_LL()) {
              setTotalSitesProcessing(Math.floor(totalElement / 2));
              setTotalSitesProcessed(Math.floor(totalAddressesCount / 2));
            } else {
              setTotalSitesProcessing(totalElement);
              setTotalSitesProcessed(totalAddressesCount);
            }

            if (content && content.length > 0) {
              setShowLoader(false);

              content.forEach((item) => {
                let hasPincodeError = false;
                let hasAddressError = false;

                if (item.locationStatus === FEASIBILITY_LOCATION_STATUS.ADDRESS_INCOMPLETE) {
                  hasAddressError = true;
                }

                if (item.locationStatus === 'PIN_INCOMPLETE') {
                  hasPincodeError = true;
                }

                const columns = isAOI ? getColumnsForAOI(item, hasAddressError, hasPincodeError) : getColumnsForDI_VPN(item, hasAddressError, hasPincodeError);
                tableColumnsList.push(columns);
              });
            }

            if (content?.length === 0 && retryCount > MAX_RETRY_COUNT) {
              setShowRetry(true);
              setInSessionStorage(MULTI_SITE_MODULE_ID, RETRY_COUNT, 0);
            }

            setTableColumns(tableColumnsList);
          }
        };

        // HANDLE COLUMN MAPPING
        if (isAOI) {
          handleAOIResolution();
        } else if (isBulkUpgrade()) {
          handleBulkUpgradeResolution();
        } else {
          // handleAOIResolution();
          handleMultiSiteNLDLLResolution();
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        setShowRetry(true);

        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useInterval(handleFetchLocations, getCbInterval());

  useEffect(() => {
    const selectedKey = dataPerPageValue && dataPerPageValue.key;
    let filterParams = {};

    if (searchType && searchValue) {
      filterParams[searchType['key']] = searchValue;
    }

    if (filterValue && filterValue.displayName !== 'All') {
      filterParams[filterValue['key']] = filterValue.displayName;
    }

    if (multiSortArr.length > 0) {
      multiSortArr.forEach((item, index) => {
        filterParams[`sort[${index}].field`] = item.key;
        filterParams[`sort[${index}].ascending`] = item.value;
      });
    }

    let timeoutId;
    if (filterApplied) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => handleFetchLocations(currentPage - 1, selectedKey, filterParams), searchType && searchValue ? SHORT_CB_DELAY : 0);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [dataPerPageValue, currentPage, searchType, searchValue, filterValue, multiSortArr, filterApplied]);

  // const disableBackButton = () => {
  //   window.history.pushState(null, null, document.URL);
  //   window.addEventListener('popstate', function () {
  //     window.history.pushState(null, null, document.URL);
  //   });
  // };

  const getTotalIncAddCountAndBwList = async (totalAddressCount) => {
    try {
      setShowLoader(true);

      const nearest10digitNumber = totalAddressCount > 10 ? Math.ceil(totalAddressCount / 10) * 10 : totalAddressCount;

      const filteredArr = defaultDataPerPageOptions.filter((item) => item.key <= nearest10digitNumber);

      if (filteredArr.length > 0) {
        setDataPerPageOptions(filteredArr);
      } else {
        setDataPerPageOptions(defaultDataPerPageOptions);
      }

      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const defaultFilterParam = {
        fields: getFieldsParam()
      };

      const { res, err } = await fetchLocationDetails(leadAuthToken, 0, totalAddressCount, defaultFilterParam);

      if (res) {
        const { data: { success = false, result = {} } = {} } = res;
        const { content = [] } = result;

        if (success) {
          setShowLoader(false);
          if (content && content.length > 0) {
            const setBulkUpgradeBwDropdownFilter = () => {
              const bandwidthList = [];

              content.forEach((item) => {
                const {
                  lsiDetail: { requestedBandwidth }
                } = item;

                const hasValue = bandwidthList.some((item) => item.displayName === requestedBandwidth);

                if (!hasValue) {
                  let bandwidthObj = {
                    key: 'bandwidth',
                    displayName: requestedBandwidth
                  };
                  bandwidthList.push(bandwidthObj);
                }
              });
              setFilterList([...defaultFilterOptions, ...bandwidthList].sort((a, b) => a.displayName - b.displayName));
            };

            const setMultiSiteNLDLLBwDropdownFilter = () => {
              const bandwidthList = [];

              content.forEach((item) => {
                let bandwidth = item.feasibilityResponseBulk.requestedBandwidth && item.feasibilityResponseBulk.requestedBandwidth.toString();

                const hasValue = bandwidthList.some((item) => item.displayName === bandwidth);

                if (!hasValue) {
                  let bandwidthObj = {
                    key: 'bandwidth',
                    displayName: bandwidth
                  };
                  bandwidthList.push(bandwidthObj);
                }
              });
              setFilterList([...defaultFilterOptions, ...bandwidthList].sort((a, b) => a.displayName - b.displayName));
            };

            if (isBulkUpgrade()) {
              setBulkUpgradeBwDropdownFilter();
            } else {
              setMultiSiteNLDLLBwDropdownFilter();
            }
          }
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleGoBack = () => setShowCancelLeadPopup(true);

  const toggelToastPopup = () => {
    setToast(false, '', '');
  };

  const handleCancelLead = async (remarks) => {
    try {
      setShowLoader(true);
      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);
      const reqData = {
        remarks
      };
      const { res, err } = await cancelLead(reqData, leadAuthToken, isdedicatedJourney);
      if (res) {
        const { data: { success = false } = {} } = res;
        if (success) {
          setShowLoader(false);
          toggelToastPopup();
          let redirectUrl = ROUTES.DEDICATED_CANCEL;
          if (partyId) {
            redirectUrl = redirectUrl + '?partyId=' + partyId;
          }
          history && history.push(redirectUrl, { ...getOrderDetails(), isUpgrade: isBulkUpgrade() });
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleGotoCheckFeasibility = async () => {
    setShowLoader(true);
    setFeasibilityCheckInProgress(true);
    if (isAOI) {
      setAccordionStateAOI(false);
    }
    try {
      setShowLoader(true);
      setFeasibilityCheckInProgress(true);

      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const { res, err } = await bulkFeasibilityCheck(leadAuthToken);
      if (res) {
        const {
          data: { success = false }
        } = res;
        if (success) {
          setInSessionStorage(MULTI_SITE_MODULE_ID, FEASIBILITY_SUCCESS, success);
          let currentLead = getCurrentLead();
          if(!currentLead){
            currentLead={}
            currentLead.serviceType=getFromSessionStorage(MODULE_ID,'productName')
            
          }
          const isAOIJourney = currentLead?.serviceType === 'DSL' || props?.isTMO || false;
          let redirectUrl = isAOIJourney ? ROUTES.AOI.DEDICATED_BULK_FEASIBILITY : ROUTES.DEDICATED_BULK_FEASIBILITY;
          if (isDevEnv() && isAuthForDev()) {
            redirectUrl = redirectUrl + '?isAuth=' + findParamFromUrl('isAuth', false);
          } else{
            
          }
          if (partyId) {
            if(isDevEnv()){
              redirectUrl = redirectUrl + '&partyId=' + partyId;
            } else{
              redirectUrl = redirectUrl + '?partyId=' + partyId;
            }
            
          }

         

          history.push(redirectUrl);
          //window && window.location.reload()
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setFeasibilityCheckInProgress(false);

        setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (err) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
      setShowLoader(false);
      setFeasibilityCheckInProgress(false);

      setToast(true, errorMsg, ERROR_TOAST);
      throw new Error(errorMsg);
    }
  };

  const handleFileUpload = (uploadedFiles, isFileUploaded) => {
    setIsEdit(isFileUploaded);
    isFileUploaded && handleClearFilter(false);
  };

  const handleEditSubmit = () => {
    handleFetchLocations(null, null, null, false);
    setShowEditModal(false);
  };

  const handleClearFilter = (reload = true) => {
    setFiltersApplied(false);
    setDataPerPageValue(defaultDataPerPageOptions[0]);
    setSearchType('');
    setSearchValue('');
    setFilterValue(() => defaultFilterOptions[0]);

    if (reload) handleFetchLocations(null, defaultFilterOptions[0]?.key, null, false);
  };

  const getSortValue = (value) => {
    if (value === 'ascending') {
      return 'descending';
    }
    if (value === 'descending') {
      return 'ascending';
    }

    return 'descending';
  };

  const handleSortClick = (key, value) => {
    const updatedRows = tableRows.map((item) => {
      if (item.sortKey === key) {
        item.sortValue = getSortValue(value);
      }
      return item;
    });

    const multiSortArrCpy = [...multiSortArr];

    const hasSortKey = multiSortArrCpy.some((item) => item.key === key);

    if (hasSortKey) {
      multiSortArrCpy.map((item) => {
        if (item.key === key) {
          item.value = getSortValue(value) === 'ascending' ? true : false;
        }

        return item;
      });
    } else {
      multiSortArrCpy.push({
        key,
        value: getSortValue(value) === 'ascending' ? true : false
      });
    }

    setFiltersApplied(true);
    setTableRows(updatedRows);
    setMultiSortArr(multiSortArrCpy);
  };

  const isProceedBtnDisabled = () => {
    return (
      (!filterApplied && parseInt(downloadPercentage) !== 100) ||
      locationStatusMap?.[FEASIBILITY_LOCATION_STATUS.INVALID_ADDRESS] > 0 ||
      feasibilityCheckInProgress ||
      tableColumns?.length === 0
    );
  };

  if (showRetry) {
    // return (
    //   <div>
    //     Something went wrong...
    //     <button onClick={() => handleFetchLocations(null, null, null, false)}>Retry</button>
    //   </div>
    // );
    return <RetryComponent onRetryClick={() => handleFetchLocations(null, null, null, false)} />;
  }

  return (
    <div className="address-resolution">
      {showCanceLeadPopup && <CancelModal setshowPopup={setShowCancelLeadPopup} onSubmit={handleCancelLead} />}
      {showStaticNotification?.show && (
        <div className="notification_section spacing_top">
          <div className="network-coverage">
            <div className={`coverageContent ${showStaticNotification.type}`}>{getNotificationTextOnCircuitUpload(showStaticNotification.props ?? {})}</div>
          </div>
        </div>
      )}
      {showEditModal && (
        <DrawerModalComponent
          isOpen={showEditModal}
          setIsOpen={setShowEditModal}
          title={isBulkUpgrade() ? 'Edit with Excel' : 'Edit Sites with Excel'}
          onSaveClick={handleEditSubmit}
          downloadHeading={isBulkUpgrade() ? 'Export excel file of all active sites/circuits' : 'Export Excel Edit File'}
          downloadSubHeading={getDownloadModalText()}
          downloadBtnName={isBulkUpgrade() ? 'Download Excel' : 'Download Excel For Edit'}
          toast={toast}
          setToast={setToast}
          currentPage={FILE_UPLOAD_PAGES.ADDRESS_RESOLUTION}
          onDrawerUploadCb={handleFileUpload}
          heading={isBulkUpgrade() ? 'Upload updated excel file' : 'Upload Excel Edited File'}
          subHeading={
            isBulkUpgrade()
              ? getUploadModalText()
              : 'Upload the Excel file of edited sites here. Please note all changes as per the uploaded file will be revised and updated on the system.'
          }
          {...props}
        />
      )}

      <CircuitDetail circuitModalDataSet={circuitModalDataSet} isOpen={showCircuitDetailModal} onClose={setShowCircuitDetailModal} />

      <Fragment>
        <AddressProcess
          addressResolutionAOIComponent={addressResolutionAOIComponent}
          showFeasibilityErrorStatus
          isAOI={isAOI}
          showProcessComponent
          showFilterOptions
          setBottomMargin={false}
          showSearchFilterOptions={false}
          processBtnName="Re-Upload Excel"
          processIdLabel={isAOI ? '' : 'Feasibility Request ID:'}
          processSiteLabel={isAOI ? 'Sites Uploaded for Feasibility' : isNLD_OR_LL() ? 'Total Links' : isBulkUpgrade() ? 'Total Sites' : 'Total Sites Processed'}
          processId={getFromSessionStorage(MULTI_SITE_MODULE_ID, LEAD_ID) || leadIdFromParam}
          // processSiteProcessed={filterApplied ? totalSitesProcessed :  tableColumns.length}
          processSiteProcessed={totalSitesProcessed}
          onProcessBtnClick={() => {
            setShowEditModal(true);
          }}
          processBtnDisabled={parseInt(downloadPercentage) !== 100}
          showAddressErrorStatus={locationStatusMap?.IN_COMPLETE > 0}
          locationStatusMap={locationStatusMap}
          showProgressComponent={parseInt(downloadPercentage) === 100 ? false : true}
          noOfProcessingSites={totalSitesProcessing}
          percentageComplete={downloadPercentage}
          filterLabel="Bandwidth"
          filterValue={filterValue}
          filterOptions={filterList}
          filterOnChange={(value) => {
            setFiltersApplied(true);
            setFilterValue(value);
          }}
          searchType={searchType}
          onSearchTypeChange={(type) => {
            setFiltersApplied(false);
            setSearchType(type);
            setSearchValue('');
          }}
          searchValue={searchValue}
          onSearchValueChange={(value) => {
            setFiltersApplied(true);
            setSearchValue(value);
          }}
          searchTypeOptions={defaultSearchTypeOptions}
          onSearchClick={() => {
            let filterParams = {};

            if (searchType && searchValue) {
              filterParams[searchType['key']] = searchValue;
            }
            handleFetchLocations(null, null, filterParams);
          }}
          onClearFilter={handleClearFilter}
          rows={tableRows}
          cols={tableColumns}
          dataPerPageValue={dataPerPageValue}
          dataPerPageOptions={dataPerPageOptions}
          dataPerPageOnChange={(val) => {
            setFiltersApplied(true);
            setDataPerPageValue(val);
          }}
          currentPage={currentPage}
          onPageSelect={(pageNo) => {
            setFiltersApplied(true);
            setShowLoader(true);
            setCurrentPage(pageNo);
          }}
          totalPages={totalPages}
          onSortClick={handleSortClick}
          filterApplied={filterApplied}
          showLoader={showLoader}
          toolTipMessage={TOOLTIP_MESSAGE.EDIT_WITH_EXCEL}
          isRowSpanEnabled={(isNLD_OR_LL() || isVPN_OR_DI()) && !isBulkUpgrade()}
          showNoRecordComp={isBulkUpgrade() && totalSitesProcessed === 0}
          isPoolingCompleted={!getCbInterval()}
        />

        {!isAOI ? (
          <div className="footer-section">
            <div className="action">
              <Button variant="outlinebtn" buttonClass="cancel-button" onClick={handleGoBack}>
                Cancel
              </Button>
              <Button className="activebtn" disabled={isBulkUpgrade() ? totalSitesProcessed === 0 : isProceedBtnDisabled()} onClick={handleGotoCheckFeasibility}>
                Next
                {feasibilityCheckInProgress && <span className="loading_icon"></span>}
              </Button>
            </div>
          </div>
        ) : (
          <BottomSection
            spaceBetween
            onSubmitClick={handleGotoCheckFeasibility}
            onCancelClick={handleGoBack}
            title="Sites Processed"
            value={totalSitesProcessed}
            isSubmitDisabled={isProceedBtnDisabled()}
            loader={feasibilityCheckInProgress}
          />
        )}
        {/* 
        <BottomSection
          spaceBetween
          onSubmitClick = {handleGotoCheckFeasibility}
          onCancelClick = {handleGoBack}
          // isSubmitDisabled = {}
        /> */}
      </Fragment>
    </div>
  );
};

export default AddressResolutionComponent;
